import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from '@app/app-config.service';
import * as moment from 'moment';
import 'moment-timezone';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

export interface Timezone {
  name: string;
  rawOffset: number;
  offset: number;
  dst: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class TimezoneService {
  cache$: Observable<Timezone[]>;

  constructor(protected http: HttpClient, protected appConfigService: AppConfigService) {}

  getAll(): Observable<Timezone[]> {
    if (!this.cache$) {
      this.cache$ = this.http.get<Timezone[]>(`${this.appConfigService.getApi()}/timezones`).pipe(shareReplay(1));
    }
    return this.cache$;
  }

  getUtcOffset(timezone: string): string {
    return moment().tz(timezone).format('Z');
  }
}
